type TProducts =
  | 'credit_facility'
  | 'business_loan'
  | 'iwocapay'
  | 'cbils'
  | 'flexi24'
  | 'recovery_loan'
  | 'merchant_cash_advance';

type TDateUnit = 'days' | 'months' | 'years';

export const getProductName = (product?: Partial<TProducts>) => {
  if (!product) return '-';

  switch (product) {
    case 'credit_facility':
      return 'Flexi-Loan';
    case 'flexi24':
      return 'Flexi-24';
    default:
      return product;
  }
};

export function getDurationInMonths(
  duration?: { amount: number; unit: TDateUnit } | null,
) {
  if (!duration) {
    return null;
  }

  switch (duration.unit) {
    case 'days':
      return Math.floor(duration.amount / 30);
    case 'months':
      return duration.amount;
    case 'years':
      return duration.amount * 12;
  }
}

export function getDurationInYears(duration: {
  amount: number;
  unit: TDateUnit;
}) {
  switch (duration.unit) {
    case 'days':
      return duration.amount / 365;
    case 'months':
      return duration.amount / 12;
    case 'years':
      return duration.amount;
  }
}
